import React, { useState } from 'react';
import { firestore, doc, setDoc } from '../firebase-config';
import '../styles/WeeklyScheduleEditor.css';

const WeeklyScheduleEditor = ({ initialSchedule = [], onSave }) => {
  const [schedule, setSchedule] = useState(
    initialSchedule.length > 0 ? initialSchedule : []
  );
  const [saving, setSaving] = useState(false);

  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const handleScheduleChange = (index, field, value) => {
    const newSchedule = [...schedule];
    newSchedule[index] = { ...newSchedule[index], [field]: value };
    setSchedule(newSchedule);
    onSave(newSchedule);
  };

  const addScheduleItem = () => {
    const newItem = {
      day: 'Sunday',
      time: '',
      name: '',
      description: ''
    };
    setSchedule([...schedule, newItem]);
  };

  const removeScheduleItem = (index) => {
    const newSchedule = schedule.filter((_, i) => i !== index);
    setSchedule(newSchedule);
    onSave(newSchedule);
  };

  const moveItemUp = (index) => {
    if (index === 0) return;
    const newSchedule = [...schedule];
    [newSchedule[index - 1], newSchedule[index]] = [newSchedule[index], newSchedule[index - 1]];
    setSchedule(newSchedule);
    onSave(newSchedule);
  };

  const moveItemDown = (index) => {
    if (index === schedule.length - 1) return;
    const newSchedule = [...schedule];
    [newSchedule[index], newSchedule[index + 1]] = [newSchedule[index + 1], newSchedule[index]];
    setSchedule(newSchedule);
    onSave(newSchedule);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const scheduleRef = doc(firestore, 'pageContent', 'weeklySchedule');
      await setDoc(scheduleRef, { schedule }, { merge: true });
      alert('Weekly schedule saved successfully!');
    } catch (error) {
      console.error('Save error:', error);
      alert('Error saving schedule: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="weekly-schedule-editor">
      <div className="schedule-editor-header">
        <h2>Manage Weekly Schedule</h2>
        <button onClick={addScheduleItem} className="add-schedule-button">
          + Add Service/Activity
        </button>
      </div>

      {schedule.length === 0 ? (
        <p className="no-schedule-message">
          No weekly services yet. Click "Add Service/Activity" to create one.
        </p>
      ) : (
        <div className="schedule-editor-list">
          {schedule.map((item, index) => (
            <div key={index} className="schedule-editor-card">
              <div className="schedule-editor-header-row">
                <h3>Service {index + 1}</h3>
                <div className="schedule-controls">
                  <button
                    onClick={() => moveItemUp(index)}
                    disabled={index === 0}
                    className="move-button"
                    title="Move up"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => moveItemDown(index)}
                    disabled={index === schedule.length - 1}
                    className="move-button"
                    title="Move down"
                  >
                    ↓
                  </button>
                  <button
                    onClick={() => removeScheduleItem(index)}
                    className="remove-schedule-button"
                  >
                    Remove
                  </button>
                </div>
              </div>

              <div className="schedule-editor-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Day of Week *</label>
                    <select
                      value={item.day}
                      onChange={(e) => handleScheduleChange(index, 'day', e.target.value)}
                      className="form-select"
                    >
                      {daysOfWeek.map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Time *</label>
                    <input
                      type="text"
                      value={item.time}
                      onChange={(e) => handleScheduleChange(index, 'time', e.target.value)}
                      placeholder="e.g., 10:45am, 6:00pm"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Service/Activity Name *</label>
                  <input
                    type="text"
                    value={item.name}
                    onChange={(e) => handleScheduleChange(index, 'name', e.target.value)}
                    placeholder="e.g., Morning Service, Prayer Meeting"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={item.description}
                    onChange={(e) => handleScheduleChange(index, 'description', e.target.value)}
                    placeholder="Optional details about this service"
                    className="form-textarea"
                    rows="2"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={saving}
        className="save-schedule-button"
      >
        {saving ? 'Saving...' : 'Save Weekly Schedule'}
      </button>
    </div>
  );
};

export default WeeklyScheduleEditor;